// Lists as lines — one per task that holds one: its title and who / when under it, the
// bar, what is still open, finished out of total. The whole line opens the list. Used by
// the job screen's card and by the lists screen; a done task's line is faded and opens
// its list read-only.
import he from '../../i18n/he';
import DateText from '../DateText';
import { ListBar, ListCounts, ListRatio } from './ListGlance';

const Sub = ({ row, withJob }) => (
  <span className="list-line-sub">
    {withJob && row.job_title && <span>{row.job_title}</span>}
    {row.assigned_partner_name && <span>{row.assigned_partner_name}</span>}
    {row.status === 'done'
      ? <span>{he.lists.doneOn} <DateText value={row.completed_at} /></span>
      : row.due_date && <span>{he.board.due} <DateText value={row.due_date} /></span>}
  </span>
);

export default function ListLines({ rows, onOpen, withJob }) {
  return (
    <div className="list-lines">
      {rows.map((r) => (
        <button key={r.task_id} type="button" className={`list-line${r.status === 'done' ? ' done' : ''}`} onClick={() => onOpen(r.task_id)}>
          <span className="list-line-title">
            <span className="list-line-name">{r.title}</span>
            <Sub row={r} withJob={withJob} />
          </span>
          <ListBar summary={r.summary} thin />
          <ListCounts summary={r.summary} />
          <ListRatio summary={r.summary} />
        </button>
      ))}
    </div>
  );
}
